import colors from '../../colors';

const globalHeader = {
  colors: {
    backgroundColor: colors.accent.dkBlue4,
    brand: colors.primary.darkGrey,
    link: colors.primary.white,
    mobileLink: colors.primary.darkGrey,
    mobileLinkBackground: colors.primary.white,
    navbarToggler: colors.primary.white,
    border: colors.transparent,
    braze: colors.primary.primary,
  },
};

export default globalHeader;
